//
//  ViewScrollState.js  <project>  ScrollView 滚动位置（有tab页,在push前单独reset）  Created
// by licheng09 on 2017-11-03.  Copyright 2017 licheng09. All rights reserved.
//

const mapState = {};
const ListScrollState = {
    set(key, { top, left }) {
        mapState[key] = {
            top,
            left,
        };
    },
    get(key) {
        return mapState[key];
    },
    reset(key) {
        // 对应的ScrollView会回到顶部 mapState[key]=null;
        mapState[key] = null;
    },

};

export default ListScrollState;



// WEBPACK FOOTER //
// ./src/components_common/ScrollView/ViewScrollState.js